/**
 * @module services/http/core
 */

import IHttpOptions from "./IHttpOptions";

/**
 * Request payload contract with backend. Contains default properties to be sent.
 *
 * @author Davinder Singh
 * @class RequestPayload
 */
class HandSetDtls{
  deviceId:string;
  imei:string;
  handsetModel:string;
  handsetMake:string;
  mobileOS:string;
  isMobileApp:string;
  celId:string;
  appVer:string;
  agentEmail:string;
  mcc:string;
  mnc:string;
  lac:string;
  userAgent:string;
  mobileNo:string;
  geoCode:string;
  mobileOperator:string;
  internetType:string;
  bcAgentId:string;
  token:string;
  constructor(){
    this.deviceId="";
    this.imei="";
    this.handsetModel="";
    this.handsetMake="";
    this.mobileOS="";
    this.isMobileApp="";
    this.celId="";
    this.appVer="";
    this.agentEmail="";
    this.mcc="";
    this.mnc="";
    this.lac="";
    this.userAgent="";
    this.mobileNo="";
    this.geoCode="";
    this.mobileOperator="";
    this.internetType="";
    this.bcAgentId="";
    this.token="";
  }
}
class RequestPayload {
  [key: string]: any;
  
constructor(httpOptions: IHttpOptions) {
}
}

function getAppGeoCode(key){
  if(appCommonData && appCommonData.geoCode){
    let data=appCommonData.geoCode.split(",");
    return key=='lat'?data[0]:data[1];
  }
  return '0';
}

export default RequestPayload;
